import styled from "styled-components";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default styled.button`
  flex: ${themeResponsiveProperty("1", "none")};
  background-color: #1d1d1b;
  color: #FFFFFF;
  border: 0;
  padding: ${themeResponsiveProperty(".5rem .625rem", ".5rem 1.25rem")};
  border-radius: .3125rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: .5rem;

  svg {
    height: 1rem;
  }

  span {
    font-size: .8125rem;
    line-height: 1.125rem;
    text-transform: uppercase;
  }
`;
